import useLocale from 'next-translate/useTranslation';
import React from 'react';

import ModelLogosMarquee from './ModelLogosMarquee';

const STATS = [
  ['40+', 'top AI models'],
  ['300+', 'templates & tools'],
  ['100+', 'languages supported'],
  ['3.4M+', 'creators on board'],
];

const ModelsBand = () => {
  const { t } = useLocale('home');

  return (
    <section className='relative border-y border-white/[0.06] bg-white/[0.02] py-16 lg:py-20'>
      <div className='mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8'>
        <h2 className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
          {t('All the latest models. One subscription.')}
        </h2>
        <p className='mx-auto mt-4 max-w-2xl text-lg text-slate-400'>
          {t(
            'New models land here days after release — no extra accounts, no juggling tabs.',
          )}
        </p>
      </div>
      <div className='mt-10'>
        <ModelLogosMarquee fadeColor='#0a0a10' />
      </div>
      <div className='mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-8 px-4 sm:px-6 md:grid-cols-4'>
        {STATS.map(([value, label]) => (
          <div key={label} className='text-center'>
            <div className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
              {value}
            </div>
            <div className='mt-1 text-sm text-slate-400'>{t(label)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ModelsBand;
